class PostcodeChecker extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector(".js-postcode-form");
    this.results = this.querySelector(".js-delivery-results");
    this.typeEl = this.querySelector(".js-delivery-type");
    this.zoneEl = this.querySelector(".js-delivery-zone");
    this.priceEl = this.querySelector(".js-delivery-price");
    this.background = this.querySelector(".js-delivery-background");
    this.altContainer = this.querySelector(".js-delivery-alt");
    this.form.addEventListener("submit", (e) => this.handleSubmit(e));
  }

  normalizePostcode(pc) {
    return pc.replace(/\s/g, "").toLowerCase();
  }

  handleSubmit(e) {
    e.preventDefault();

    const rawInput = this.form.querySelector("#map-input")?.value || "";
    const postcodeInput = this.normalizePostcode(rawInput);
    const zonesArray = window.deliveryChargeZones || [];
    const matchingZones = zonesArray.filter(zone => {
      return zone.postcode.split(",").some(pc => postcodeInput.startsWith(this.normalizePostcode(pc)));
    });
    matchingZones.reverse();

    if (matchingZones.length > 0) {
      const main = matchingZones[0];
      if (this.typeEl) this.typeEl.textContent = main.type || "";
      if (this.zoneEl) this.zoneEl.textContent = main.name || "";
      if (this.priceEl) this.priceEl.textContent = main.price || "";
      if (this.background) this.background.style.backgroundColor = main.backgroundColor || "#000";

      this.renderAltZones(matchingZones.slice(1));
    } else {
      if (this.typeEl) this.typeEl.textContent = "";
      if (this.zoneEl) this.zoneEl.textContent = " DELIVERY UNAVAILABLE";
      if (this.priceEl) this.priceEl.textContent = "";
      if (this.background) this.background.style.backgroundColor = "rgb(56, 56, 54)";

      if (this.altContainer) {
        this.altContainer.innerHTML = "";
        this.altContainer.classList.add("hidden");
      }
    }
    if (this.results) {
      this.results.classList.remove("hidden");
    }
  }

  renderAltZones(zones) {
    if (!this.altContainer) return;

    if (zones.length === 0) {
      this.altContainer.innerHTML = "";
      this.altContainer.classList.add("hidden");
      return;
    }

    let html = "";
    let description = "";
    zones.forEach(zone => {
      html += `
        <div class=" postcode-col bg-grey-40 text-white text-center pt-7 pb-5 mt-3" style="background-color: ${zone.backgroundColor || '#999'}">
          <div class="font-black title-text">${zone.type || ''}</div>
          <div class="font-black zone-text">${zone.name || ''}</div>
          <div class="font-black price-text uppercase">${zone.price || ''}</div>
        </div>
      `;
      if (!description && zone.description) {
        description = zone.description;
      }
    });
    if (description) {
      html += `
        <div class="text-sm mt-4 postcode-zone-description">
          ${description}
        </div>
      `;
    }
    this.altContainer.innerHTML = html;
    this.altContainer.classList.remove("hidden");
  }
}

customElements.define("postcode-checker", PostcodeChecker);
